import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import enRecruitment from "./locales/recruitmentJson/en.json"
import mnRecruitment from "./locales/recruitmentJson/mn.json"

import mnFeedback from "./locales/feedbackJson/mn.json"
import enFeedback from "./locales/feedbackJson/en.json"

import mnWhistle from "./locales/whistleJson/mn.json"
import enWhistle from "./locales/whistleJson/en.json"


i18n.use(initReactI18next).init({
    resources: {
        en: {
            recruitment: enRecruitment,
            feedback: enFeedback,
            whistle: enWhistle,
        },
        mn: {
            recruitment: mnRecruitment,
            feedback: mnFeedback,
            whistle: mnWhistle,
        },
    },
    lng: "mn",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    }
});

export default i18n;